import Label from "components/Label/Label";
import React from "react";
import { FC } from "react";

export interface FormItemProps {
  className?: string;
  label?: string;
  desc?: string;
  requirement?: string;
  children?: React.ReactNode;
}

const FormItem: FC<FormItemProps> = ({
  children,
  className = "",
  label,
  desc,
  requirement,
}) => {
  return (
    <div className={className}>
      <div className="flex items-center justify-between">
        {label && <Label>{label}</Label>}
        {requirement && (
          <span className="block mt-3 text-xs text-primary-500 dark:text-primary-400 ">
            {requirement}
          </span>
        )}
      </div>
      <div className="mt-1">{children}</div>
      {desc && (
        <span className="block mt-3 text-xs text-neutral-500 dark:text-neutral-400 ">
          {desc}
        </span>
      )}
    </div>
  );
};

export default FormItem;
